import React, { useState, useEffect } from 'react'
import { Snackbar } from '@mui/material'
import { appStore } from '../store/store';
import { initializeInactivityTimeout } from '../utils/InactivityTimeout';
import { collect } from 'react-recollect';

const TimeoutWarning = ({ store }) => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!appStore.isLoggedIn()) return;
    const { setup, cleanup } = initializeInactivityTimeout(
      () => setShowWarning(true),
      () => setShowWarning(false)
    )
    setup();

    return () => cleanup();
  }, [store.currentUser]);
  // We use a dependency array, so that, when we logout and log back in, the effect runs again

  return (
    <Snackbar
      open={showWarning}
      message={<span>You will be logged out in 2 minutes if there is no activity.</span>}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      ContentProps={{
        sx: { backgroundColor: '#fff3cd', color: '#856404', border: '2px solid #f57c00' }
      }}
    />
  )
}

export default collect(TimeoutWarning)